<script>
export default {
  name: 'NewApp',
  components: {
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    isIOSMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="new-app">
    <BModal :active="isModalOpen" :full-screen="true" trap-focus :can-cancel="false">
      <div class="new-app__content">
        <div class="new-app__content__background-phone" />
        <div class='new-app__content__header'>
          <div class='new-app__content__header__main-text'>
            Nueva app disponible
          </div>
          <div class='new-app__content__header__sub-text'>
            Haz click para actualizar
            <div class='new-app__content__header__sub-text__arrow'>
              <img src='/images/new-app/arrow.svg' />
            </div>
          </div>
        </div>
        <div class='new-app__content__button-store'>
          <div v-if='isIOSMobile' class='button-ios' @click="$emit('click-store', 'iOS')">
            <img src='/images/new-app/appstore.svg' />
          </div>
          <div v-else class='button-android' @click="$emit('click-store', 'android')">
            <img src='/images/new-app/background-button.svg' />
            <div class='play-store__img'>
              <img src='/images/new-app/googleplay.svg' />
            </div>
          </div>
        </div>
        <div class='new-app__content__later' @click="$emit('close')">
          Más tarde
        </div>
      </div>
    </BModal>
  </div>
</template>

<style scoped lang='scss'>
.new-app {
  background-color: transparent;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    border-radius: 5px;
    background-image: linear-gradient(to bottom, #27664b, #0d1d29);
    font-family: 'Poppins-Regular';

    &__background-phone {
      position: absolute;
      top: 7%;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url('/images/new-app/iphone_isometric@3x.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &__header {
      color: white;

      &__main-text {
        font-size: 22px;
        margin-top: 30px;
      }

      &__sub-text {
        font-size: 14px;
        margin-top: 4px;
        position: relative;

        &__arrow {
          position: absolute;
          top: 5px;
          right: 4px;
          width: 20px;
          height: 20px;
        }
      }
    }

    &__button-store {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      z-index: 5;
    }

    &__later {
      position: absolute;
      bottom: 25px;
      font-size: 14px;
      text-decoration: underline;
      color: #b2b6b9;
      cursor: pointer;
      z-index: 5;
    }
  }
}

.button-ios {
  width: 60%;
  aspect-ratio: 253 / 73;
}

.button-android {
  width: 65%;
  aspect-ratio: 836 / 219;
  position: relative;

  & .play-store__img {
    position: absolute;
    width: 84%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style lang='scss'>
.new-app {
  & .modal.is-full-screen > .animation-content, .modal.is-full-screen > .animation-content > .modal-card {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    margin: 0;
    /* background-color: whitesmoke; */
    display: flex;
    justify-content: center;
    background-color: transparent !important;
  }

  & .modal-content, .modal-card {
    @media screen and (max-width: 440px) {
      max-height: calc(100vh - 0px) !important;
      margin-top: 0 !important;
    }
  }
}
</style>
